import {
  STATION_INDICATOR_BADGE_ICON_FONT_SIZE,
  StationIndicatorBadge,
} from '@app/components/stations/StationIndicatorBadge';
import { sharedStationTooltipMessage } from '@app/components/stations/station-messages';
import { isSharedStation } from '@app/core/stations/helpers';
import { Station } from '@app/core/types/stations';
import PublicIcon from '@mui/icons-material/Public';
import { Box, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';

interface StatusSharedStationBadgeProps {
  station: Station;
  compact: boolean;
}

/**
 * Inline shared-station badge shown next to the station name in the status header.
 */
export function StatusSharedStationBadge({ station, compact }: StatusSharedStationBadgeProps) {
  const { $t } = useIntl();
  const size = compact ? 'small' : 'medium';

  if (!isSharedStation(station)) {
    return null;
  }

  return (
    <Tooltip title={$t(sharedStationTooltipMessage)} placement="top">
      <Box component="span" display="inline-flex">
        <StationIndicatorBadge size={size} className="status-card__shared-station-badge">
          <PublicIcon
            sx={{
              fontSize: STATION_INDICATOR_BADGE_ICON_FONT_SIZE[size],
              color: 'text.secondary',
            }}
          />
        </StationIndicatorBadge>
      </Box>
    </Tooltip>
  );
}
